import { Injectable } from '@angular/core';
import {
  ContentSocialIcon,
  FooterColumn
} from '@com-delta-idp/mnx-sitewide-footer-ui';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { FooterExtendedAdapterService } from './footer-extended.adapter.service';

@Injectable({
  providedIn: 'root'
})
export class FooterAdapterService extends FooterExtendedAdapterService {
  deepLinkCacheKey: string | undefined;
  restrictProfileSelector = false;
  disableCLS: boolean | string = '';
  prefCookieValue: string | null = '';
  contentLoaded = false;

  getSocialIconContent(
    headerFooterJson: HeaderFooterMachCore
  ): ContentSocialIcon[] {
    const socialIconsList = headerFooterJson.footer.socialIcons;
    const socialIcons = socialIconsList.map((icon) => {
      return {
        iconAlt: icon.iconAlt,
        iconLink: icon.iconLink,
        iconLogo: icon.iconLogo,
        openExternalLinkModal: icon.openExternalLinkModal,
        avoidFocus: false,
        containerClass: ''
      };
    });
    return socialIcons;
  }

  getBusinessUser(): boolean {
    const account = this.cookieHelper.getAccountCookie('account');
    if (account && account.length) {
      const parseAccount = JSON.parse(account);
      return parseAccount['isBusiness'];
    }
    return false;
  }

  getDisableBusinessHomePage(headerFooterDetails: HeaderFooterMachCore): void {
    if (
      headerFooterDetails.header.disableBusinessHomePage &&
      headerFooterDetails.header.disableBusinessHomePage !== ''
    ) {
      this.getDisableBusinessHomePageLogic(
        headerFooterDetails.header.disableBusinessHomePage === 'true'
          ? true
          : false
      );
    } else {
      this.getDisableBusinessHomePageLogic(true);
    }
  }

  getDisableBusinessHomePageLogic(disableBusinessHomePage: boolean): void {
    if (disableBusinessHomePage) {
      this.partnerId = 'default';
    } else {
      this.hasCorpCookie = this.cookieHelper.getCookies('corp');
      if (this.hasCorpCookie) {
        this.partnerId = 'edp';
        this.switchingAccountService.setIntranetlink(true);
      }
    }
  }

  getFooterColumnDetails(
    headerFooterDetails: HeaderFooterMachCore
  ): FooterColumn {
    return {
      footerColumn: this.getFooterColumnItems(headerFooterDetails),
      externalSiteNavigate: {
        iconPath: headerFooterDetails.footer.info.externalImgPath,
        label: headerFooterDetails.footer.info.footerExtDesc
      }
    };
  }

  getAdditionalInfo(headerFooterDetails: HeaderFooterMachCore): string {
    const countryCode = this.cookieHelper.getCountryCode();
    const additionalInfo = headerFooterDetails.footer?.additionalInfo?.find(
      (info) => info['countryCode'] === countryCode
    );
    return additionalInfo ? additionalInfo['info'] : '';
  }
}
